import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  checkPermisson, getActiveModal, getModalData, getTennisCompetitions,
} from '../../selectors/common';
import { liveScoreStatus } from '../../selectors/liveScoreStatus';

import LiveScoreStatusTable from './LiveScoreStatusTable';
import SavePromptModal from '../../components/Modals/SavePromptModal';
import { LIVE_SCORE_STATUS, MODALS } from '../../constants';
import { aSetOpenModal } from '../../reducers/common';
import { aGetLiveScoreStatusRequest, aUpdateLiveScoreStatusRequest } from '../../reducers';
import { aClearLiveScoreStatus } from '../../reducers/liveScoreStatus';

const mapToProps = (state) => ({
  modalData: getModalData(state),
  activeModal: getActiveModal(state),
  liveScoreStatus: liveScoreStatus(state),
  competitions: getTennisCompetitions(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
});

const actionsToProps = (dispatch) => ({
  setOpenModal: (payload) => dispatch(aSetOpenModal(payload)),
  getLiveScoreStatus: (payload) => dispatch(aGetLiveScoreStatusRequest(payload)),
  updateLiveScoreStatus: (payload) => dispatch(aUpdateLiveScoreStatusRequest(payload)),
  clearLiveScoreStatus: (payload) => dispatch(aClearLiveScoreStatus(payload)),
});
class LiveScoreStatus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedBtnStatus: null,
      selectedDropdown: null,
      liveScoreList: [],
    };
  }

  componentDidMount() {
    this.props.getLiveScoreStatus();
  }

  componentDidUpdate() {
    if (this.state.liveScoreList.length === 0 && this.props.liveScoreStatus.length !== 0) {
      this.setState({
        liveScoreList: this.props.liveScoreStatus,
      });
    }
  }

  componentWillUnmount() {
    this.props.clearLiveScoreStatus();
  }

  enableDisableStatus = (idCompetition) => {
    this.setState({
      selectedBtnStatus: idCompetition,
    });
  };

  toggleStatusDropdown = (idCompetition) => {
    this.setState({
      selectedDropdown: this.state.selectedDropdown ? null : idCompetition,
    });
  };

  handleStatusDropdown = (competitionId, status) => {
    const currentLiveScoreList = this.state.liveScoreList.map((liveScore) => ({ ...liveScore }));
    const liveScoreIndex = this.state.liveScoreList.findIndex(
      (liveScore) => liveScore.competitionId === competitionId,
    );
    currentLiveScoreList[liveScoreIndex].status = status;

    this.setState({
      liveScoreList: currentLiveScoreList,
      selectedDropdown: null,
    });
  };

  confirmBtnStatusModal = (competitionId) => {
    const liveScoreSelected = this.state.liveScoreList.find(
      (liveScore) => liveScore.competitionId === competitionId,
    );
    const competitionName = this.props.competitions
      .find((comp) => comp.id === liveScoreSelected.competitionId)?.name;
    this.props.setOpenModal({
      modal: MODALS.SAVE_BEFORE_NAVIGATION,
      modalData: {
        title: `Are you sure you want to set the LiveScore for ${competitionName} 
        to Status ${LIVE_SCORE_STATUS[liveScoreSelected.status]}?`,
        additionalMessages: ['Your changes will be lost if you don\'t save the'],
        competitionId,
      },
    });
  };

  closeBtnConfirmation = (competitionId) => {
    const currentLiveScoreList = this.state.liveScoreList.map((liveScore) => ({ ...liveScore }));
    const liveScoreIndex = this.state.liveScoreList.findIndex(
      (liveScore) => liveScore.competitionId === competitionId,
    );
    currentLiveScoreList[liveScoreIndex].status = this.props.liveScoreStatus[liveScoreIndex].status;
    this.setState({
      selectedBtnStatus: null,
      selectedDropdown: null,
      liveScoreList: currentLiveScoreList,
    });
  };

  saveChange = (competitionId) => {
    const liveScoreChanged = this.state.liveScoreList.find(
      (liveScore) => liveScore.competitionId === competitionId,
    );

    this.props.updateLiveScoreStatus(liveScoreChanged);
    this.props.setOpenModal({ modal: '' });
    this.setState({
      selectedBtnStatus: null,
      selectedDropdown: null,
    });
  };

  removeConfirmationModal = (competitionId) => {
    this.props.setOpenModal({ modal: '' });
    this.closeBtnConfirmation(competitionId);
  };

  render() {
    return (
      <>
        <div className="table-wrapper m-t-30">
          <div className="table-holder">
            <table className="table-style">
              <thead>
                <tr>
                  <th>Competition </th>
                  <th>Livescore Status</th>
                  <th> </th>
                </tr>
              </thead>
              <tbody>
                <LiveScoreStatusTable
                  checkPermisson={this.props.checkPermisson}
                  liveScoreList={this.state.liveScoreList}
                  competitions={this.props.competitions}
                  selectedBtnStatus={this.state.selectedBtnStatus}
                  toggleEnableDisableBtn={this.enableDisableStatus}
                  toggleStatusDropdown={this.toggleStatusDropdown}
                  selectedDropdown={this.state.selectedDropdown}
                  handleStatusDropdown={this.handleStatusDropdown}
                  closeBtnConfirmation={this.closeBtnConfirmation}
                  confirmBtnStatus={this.confirmBtnStatusModal}
                />
              </tbody>
            </table>
          </div>
        </div>
        {this.props.activeModal === MODALS.SAVE_BEFORE_NAVIGATION && (
          <SavePromptModal
            modalData={this.props.modalData}
            cancel={this.removeConfirmationModal.bind(this, this.props.modalData.competitionId)}
            confirmation={this.saveChange.bind(this, this.props.modalData.competitionId)}
            confirm="Save"
            cancelled="Don't Save"
          />
        )}
      </>
    );
  }
}
export default connect(mapToProps, actionsToProps)(LiveScoreStatus);
